/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Terrain estimation from the coproperty point; every value is optional, warnings explain what is missing and why.
 * @export
 * @interface TerrainEstimationDto
 */
export interface TerrainEstimationDto {
    /**
     * 
     * @type {number}
     * @memberof TerrainEstimationDto
     */
    altitudeMeters?: number | null;
    /**
     * Cadastral area of the parcel under the point, in m².
     * @type {number}
     * @memberof TerrainEstimationDto
     */
    parcelArea?: number | null;
    /**
     * Sum of the ground footprints of the buildings whose centre is inside the parcel, in m².
     * @type {number}
     * @memberof TerrainEstimationDto
     */
    buildingsFootprint?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TerrainEstimationDto
     */
    buildingsCount?: number | null;
    /**
     * parcelArea − buildingsFootprint, floored at zero; absent when the parcel is unknown.
     * @type {number}
     * @memberof TerrainEstimationDto
     */
    greenSpaceArea?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerrainEstimationDto
     */
    sources: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerrainEstimationDto
     */
    warnings: Array<string>;
}

/**
 * Check if a given object implements the TerrainEstimationDto interface.
 */
export function instanceOfTerrainEstimationDto(value: object): value is TerrainEstimationDto {
    if (!('sources' in value) || value['sources'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    return true;
}

export function TerrainEstimationDtoFromJSON(json: any): TerrainEstimationDto {
    return TerrainEstimationDtoFromJSONTyped(json, false);
}

export function TerrainEstimationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerrainEstimationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'altitudeMeters': json['altitudeMeters'] == null ? undefined : json['altitudeMeters'],
        'parcelArea': json['parcelArea'] == null ? undefined : json['parcelArea'],
        'buildingsFootprint': json['buildingsFootprint'] == null ? undefined : json['buildingsFootprint'],
        'buildingsCount': json['buildingsCount'] == null ? undefined : json['buildingsCount'],
        'greenSpaceArea': json['greenSpaceArea'] == null ? undefined : json['greenSpaceArea'],
        'sources': json['sources'],
        'warnings': json['warnings'],
    };
}

export function TerrainEstimationDtoToJSON(json: any): TerrainEstimationDto {
    return TerrainEstimationDtoToJSONTyped(json, false);
}

export function TerrainEstimationDtoToJSONTyped(value?: TerrainEstimationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'altitudeMeters': value['altitudeMeters'],
        'parcelArea': value['parcelArea'],
        'buildingsFootprint': value['buildingsFootprint'],
        'buildingsCount': value['buildingsCount'],
        'greenSpaceArea': value['greenSpaceArea'],
        'sources': value['sources'],
        'warnings': value['warnings'],
    };
}

